import { Field } from "@/components/form/field";
import { Action, ActionForm, ActionSubmit } from "@/lib/action";
import { ComponentProps } from "react";
import { FieldValues, Path } from "react-hook-form";

export function createForm<T extends FieldValues>({
  action,
  id,
}: {
  action: Action<T>;
  id?: string;
}) {
  return {
    Form: (
      props: Omit<ComponentProps<typeof ActionForm<T>>, "action"> & {
        action?: Action<T>;
      }
    ) => {
      return (
        <ActionForm<T> id={id} {...props} action={props.action ?? action} />
      );
    },
    Field: (
      props: Omit<ComponentProps<typeof Field>, "name"> & {
        name: Path<T>;
      }
    ) => {
      return <Field {...props} />;
    },
    Submit: (props: ComponentProps<typeof ActionSubmit>) => {
      return <ActionSubmit {...props} form={id} />;
    },
  };
}
